import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select'
import { cn } from 'src/enviroment/lib/utils'

export interface SelectOption<T extends string> {
  label: string
  value: T
  disabled?: boolean
}

interface OptionSelectProps<T extends string> {
  value: T
  options: SelectOption<T>[]
  onChange: (value: T) => void
  className?: string
  placeholder?: string
  disabled?: boolean
}

const OptionSelect = <T extends string>({
  value,
  options,
  onChange,
  className,
  placeholder = 'Select',
  disabled,
}: OptionSelectProps<T>) => {
  const currentLabel = options.find((o) => o.value === value)?.label ?? placeholder

  return (
    <Select value={value} disabled={disabled} onValueChange={(newValue: T) => onChange(newValue)}>
      <SelectTrigger className={cn('w-full font-inter text-base', className)}>
        <SelectValue>{currentLabel}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            className={cn('font-inter text-base', option.disabled && ' text-gray-500')}
            disabled={option.disabled}
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export default OptionSelect
